module.exports = __webpack_public_path__ + "static/projector-screen-478e9d0db9a0cfeb62c97fdf76fd042d.png";